import { useEffect } from "react";
import { setApiTokenGetter } from "@/lib/api";
import { useAuth } from "@/features/auth/auth-provider";
import { useE2eAuth } from "@/features/auth/e2e-auth-provider";

interface ApiAuthBridgeProps {
  children: React.ReactNode;
}

const isE2eAuth = import.meta.env.VITE_E2E_AUTH_BYPASS === "true";

function PrivyApiAuthBridge({ children }: ApiAuthBridgeProps) {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    setApiTokenGetter(getAccessToken);
  }, [getAccessToken]);

  return children;
}

function E2eApiAuthBridge({ children }: ApiAuthBridgeProps) {
  const { getAccessToken } = useE2eAuth();

  useEffect(() => {
    setApiTokenGetter(getAccessToken);
  }, [getAccessToken]);

  return children;
}

/** Wires access tokens into the shared apiFetch client */
export function ApiAuthBridge({ children }: ApiAuthBridgeProps) {
  if (isE2eAuth) {
    return <E2eApiAuthBridge>{children}</E2eApiAuthBridge>;
  }
  return <PrivyApiAuthBridge>{children}</PrivyApiAuthBridge>;
}
